import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import useGet from '@/core/composables/api/useGet'

export type OrganizationMember = {
  id: string
  firstName?: string
  lastName?: string
  canLogin: boolean
  accessCode: string | null
}

export const useOrganizationMember = () => {
  const route = useRoute()
  const memberId = computed(() => {
    const id = route.params.memberId
    return typeof id === 'string' ? id : undefined
  })
  const endpoint = computed(() => `members/${memberId.value}`)

  const { data: member, status, load } = useGet<OrganizationMember>(endpoint)

  watch(
    memberId,
    (id) => {
      if (id) {
        load()
      }
    },
    { immediate: true },
  )

  return {
    member,
    status,
  }
}
